<template>
  <div v-show="initialized">
    <div class="hearing-aid-sales__filters">
      <div class="filter-sales-dates__from-date filter-selection">
        <div class="filter-selection__title">From:</div>
        <div class="filter-selection__body">
          <StoreConnectedDatePicker
              class="filter-selection__select filter-selection__select--date"
              :store="store"
              :action="action"
              name="dateFrom"
              placeholder="From"
              format="MMM yyyy"
              :disabled-dates="disabledRangeFrom"
              minimum-view="month"
          ></StoreConnectedDatePicker>
        </div>
      </div>

      <div class="filter-sales-dates__to-date filter-selection">
        <div class="filter-selection__title">To:</div>
        <div class="filter-selection__body">
          <StoreConnectedDatePicker
              class="filter-selection__select filter-selection__select--date"
              :store="store"
              :action="action"
              name="dateTo"
              placeholder="To"
              format="MMM yyyy"
              :disabled-dates="disabledRangeTo"
              minimum-view="month"
          ></StoreConnectedDatePicker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min';
  import StoreConnectedDatePicker from '../../form-items/StoreConnectedDatePicker.vue';

  export default {
    name: 'Filters',
    components: {
      MoonLoader,
      StoreConnectedDatePicker,
    },
    data() {
      return {
        store: 'purchaseActivity',
        action: 'setProperty',
        loading: true,
        initialized: false,
      }
    },
    async created() {
      await this.$store.dispatch('purchaseActivity/setPurchaseActivityCardDefaults');
      this.$store.dispatch('purchaseActivity/purchaseActivityCardFiltersUpdated');
      this.loading = false;
      this.initialized = true;
    },
    computed: {
      ...mapGetters('purchaseActivity', [
        'disabledRangeFrom',
        'disabledRangeTo',
        'filters',
        'dateFrom',
        'dateTo',
        'initialValues',
        'initializers',
      ]),
      compDateTo() {
        return moment(this.dateTo).toDate();
      },
      compDateFrom() {
        return moment(this.dateFrom).toDate();
      },
    },
    watch: {
      compDateTo() {
        if (this.initializers.initialCardLoaded) {
          this.$store.dispatch('purchaseActivity/purchaseActivityCardFiltersUpdated');
        }
      },
      compDateFrom() {
        if (this.initializers.initialCardLoaded) {
          this.$store.dispatch('purchaseActivity/purchaseActivityCardFiltersUpdated');
        }
      },
      disabledRangeFrom() {
        if (this.compDateFrom < this.disabledRangeFrom.to) {
          this.$store.dispatch('purchaseActivity/setProperty', { key: 'dateFrom', value: this.disabledRangeFrom.to });
        }
        if (this.compDateFrom > this.disabledRangeFrom.from) {
          this.$store.dispatch('purchaseActivity/setProperty', { key: 'dateFrom', value: this.disabledRangeFrom.from });
        }
      },
      disabledRangeTo() {
        if (this.compDateTo < this.disabledRangeTo.to) {
          this.$store.dispatch('purchaseActivity/setProperty', { key: 'dateTo', value: this.disabledRangeTo.to });
        }
        if (this.compDateTo > this.disabledRangeTo.from) {
          this.$store.dispatch('purchaseActivity/setProperty', { key: 'dateTo', value: this.disabledRangeTo.from });
        }
      },
    },
  };
</script>
